import React, { useState, useRef, useEffect } from "react";
import boxIcon from "../../assets/images/box_icon.png";
import refreshIcon from "../../assets/images/refresh.png";
import locationIcon from "../../assets/images/locationIcon.png";
import addMemberIcon from "../../assets/images/+member.png";
import three_dots from "../../assets/images/three_dots.png";
import tickIcon from "../../assets/images/tick.png";
import crossIcon from "../../assets/images/cross_reject.png";
// import comeLater from "../../assets/images/come_later.png";
import comeLaterEN from "../../assets/images/come_later.png";
import comeLaterHI from "../../assets/images/come_later_hi.png";
import comeLaterMR from "../../assets/images/come_later_mr.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CommonTitle from "../common/DeliveryCommonTitle";
import { useDeliverySession } from "../../hooks/useDeliverySession"; // adjust the path as needed
import LoadingSpinner from "../common/LoadingSpinner";
import { useTranslation } from "react-i18next";
import CommonPopup from "../common/SummaryScreenPopup"; // adjust path if needed
import {
  monitorResidentAuth,
  sendMessageAPI,
  sendDeliverySessionAPI,
} from "../../services/delivery_api"; // adjust path

// 🟢 Modified CircularTimerLoader to use passed start time
const CircularTimerLoader = ({ startTime, resident_token, setSession }) => {
  // console.log("calling loader");
  const [progress, setProgress] = useState(0);
  const [hasMarkedStarted, setHasMarkedStarted] = useState(false);
  const [hasMarkedCompleted, setHasMarkedCompleted] = useState(false); // ✅ added

  const radius = 24;
  const strokeWidth = 8;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    const [hours, minutes, seconds] = startTime.split(":").map(Number);
    const startDate = new Date();
    startDate.setHours(hours, minutes, seconds, 0);
    const startTimestamp = startDate.getTime();

    const interval = setInterval(() => {
      const now = new Date();
      const nowTimestamp = now.getTime();

      const elapsed = nowTimestamp - startTimestamp;
      const progressValue = Math.min((elapsed / 30000) * 100, 100);
      setProgress(progressValue);

      // ✅ Console logs
      const pad = (n) => n.toString().padStart(2, "0");
      const currentTimeStr = `${pad(now.getHours())}:${pad(
        now.getMinutes()
      )}:${pad(now.getSeconds())}`;
      // console.log("🕓 Current Time:", currentTimeStr);
      // console.log("⏳ Start Time:  ", startTime);

      if (!hasMarkedStarted && progressValue > 0) {
        setSession((prevSession) => ({
          ...prevSession,
          deliveries: prevSession.deliveries.map((delivery) =>
            delivery.resident_token === resident_token
              ? { ...delivery, circular_loader: "start" }
              : delivery
          ),
        }));
        setHasMarkedStarted(true);
      }

      // ✅ When loader completes, mark it stopped & increment count ONCE
      if (progressValue >= 100 && !hasMarkedCompleted) {
        setSession((prevSession) => ({
          ...prevSession,
          deliveries: prevSession.deliveries.map((delivery) =>
            delivery.resident_token === resident_token
              ? {
                  ...delivery,
                  circular_loader: "stop",
                  authentication_count:
                    (delivery.authentication_count || 0) + 1,
                }
              : delivery
          ),
        }));
        setHasMarkedCompleted(true); // ✅ prevent future updates
        clearInterval(interval); // ✅ stop the loop
      }
    }, 100); // check every 100ms

    return () => clearInterval(interval);
  }, [
    startTime,
    resident_token,
    setSession,
    hasMarkedStarted,
    hasMarkedCompleted,
  ]); // ✅ include new state in deps

  if (progress >= 100) return null;

  return (
    <svg width="60" height="60" viewBox="0 0 120 120">
      <circle
        cx="60"
        cy="60"
        r={radius}
        fill="none"
        stroke="#e5e7eb"
        strokeWidth={strokeWidth}
      />
      <circle
        cx="60"
        cy="60"
        r={radius}
        fill="none"
        stroke="#14AE5C"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={circumference - (progress / 100) * circumference}
        strokeLinecap="round"
        transform="rotate(-90 60 60)"
        style={{ transition: "stroke-dashoffset 0.1s linear" }}
      />
    </svg>
  );
};

const DeliverySummaryScreen = ({
  onBack,
  setStep,
  onNext,
  setResidentDetails,
  setParcelCount
}) => {

  const scrollContainerRef = useRef(null);
  const { session, setSession, resetSessionForNextUse } = useDeliverySession(); // ✅ Added setSession
  const [showPendingPopup, setShowPendingPopup] = useState(false);
  const [pendingStep, setPendingStep] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [menuPosition, setMenuPosition] = useState(null);
  const [editingToken, setEditingToken] = useState(null);
  const [activeMenuToken, setActiveMenuToken] = useState(null);
  const [editingParcelValue, setEditingParcelValue] = useState(null);
  const [originalParcelValue, setOriginalParcelValue] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const { t } = useTranslation();
  const { t, i18n } = useTranslation();

  const getComeLaterImage = () => {
    switch (i18n.language) {
      case "hi":
        return comeLaterHI;
      case "mr":
        return comeLaterMR;
      case "en":
      default:
        return comeLaterEN;
    }
  };




  const [popupData, setPopupData] = useState({
    title: "",
    message: "",
    singleButton: false,
    singleButtonLabel: "Okay",
  });

  const getCurrentTimeFormatted = () => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
      now.getSeconds()
    )}`;
  };

  // ✅ useEffect to patch reauthentication_timer to current time
  useEffect(() => {
    if (!session?.deliveries || !setSession) return;

    const nowFormatted = getCurrentTimeFormatted();
    const updatedDeliveries = session.deliveries.map((delivery) => {
      if (
        !delivery.reauthentication_timer ||
        delivery.reauthentication_timer === "None"
      ) {
        return {
          ...delivery,
          reauthentication_timer: nowFormatted,
        };
      }
      return delivery;
    });

    const hasUpdates = session.deliveries.some(
      (d) => !d.reauthentication_timer || d.reauthentication_timer === "None"
    );

    // saving in session
    if (hasUpdates) {
      setSession((prev) => ({
        ...prev,
        deliveries: updatedDeliveries,
      }));
    }
  }, [session?.deliveries, setSession]);

  const isWithin30Seconds = (reauthentication_timer) => {
    if (!reauthentication_timer || reauthentication_timer === "None")
      return false;

    const [h, m, s] = reauthentication_timer.split(":").map(Number);
    const timerDate = new Date();
    timerDate.setHours(h, m, s, 0);
    const now = new Date();

    const diffInMs = Math.abs(now.getTime() - timerDate.getTime());
    return diffInMs <= 30000; // ✅ within 30 seconds
  };

  const sendAuthenticationMessage = async (member) => {
    try {
      console.log("member section ---", member);
      const payload = {
        phone_number: member.resident_phone_number,
        message: `Hi ${member.name}, please approve your delivery for ${member.company_nm} using this link ${member.resident_approval_link}.`,
      };

      console.log("📨 Sending re-authentication message:", payload);

      const response = await sendMessageAPI(payload);

      console.log("✅ Message sent successfully:", response);
      toast.success("Approval link sent!");
    } catch (error) {
      console.error("❌ Failed to send re-authentication message:", error);
      toast.error("Failed to send message!");
    }
  };

  const handleRefresh = async () => {
    if (isRefreshing) return; // 🚫 Prevent multiple clicks
    setIsRefreshing(true);

    const payload = {
      session_file_name: session.deliveries[0].session_file_name,
      complex_location: session.deliveries[0].complex_location,
      complex_name: session.deliveries[0].complex_name,
    };

    try {
      console.log("🔄 Refreshing authentication data...");
      const response = await monitorResidentAuth(payload);

      const newDeliveries = response?.data?.session_data?.deliveries || [];
      const currentDeliveries = session?.deliveries || [];

      // Store the full response if session status is not "inactive"
      const newSessionData = response?.data?.session_data;

      if (newSessionData && newSessionData.status !== "inactive") {
        console.log("Updating session because status is ACTIVE");

        setSession(newSessionData);
        localStorage.setItem(
          "deliverySession",
          JSON.stringify(newSessionData)
        );
      }

      if (!newDeliveries.length || !currentDeliveries.length) return;

      const updatedDeliveries = currentDeliveries.map((oldDelivery) => {
        const match = newDeliveries.find(
          (newDelivery) =>
            newDelivery.resident_token === oldDelivery.resident_token
        );

        if (match && match.is_authenticated !== oldDelivery.is_authenticated) {
          return {
            ...oldDelivery,
            is_authenticated: match.is_authenticated,
          };
        }

        return oldDelivery;
      });

      const hasChanges = updatedDeliveries.some(
        (d, i) => d.is_authenticated !== currentDeliveries[i].is_authenticated
      );

      if (hasChanges) {
        setSession((prev) => ({
          ...prev,
          deliveries: updatedDeliveries,
        }));
        console.log("✅ Authentication status updated in session.");
      } else {
        console.log("ℹ️ No changes in authentication status.");
      }

      if (scrollContainerRef?.current) {
        scrollContainerRef.current.scrollLeft =
          scrollContainerRef.current.scrollWidth;
      }
    } catch (err) {
      console.error("❌ Failed to refresh session:", err);
    } finally {
      setIsRefreshing(false);
    }
  };

  const members = (session?.deliveries || []).map((delivery) => {
    const isTimerNone = delivery.reauthentication_timer === "None";
    const adjustedTimer = isTimerNone
      ? getCurrentTimeFormatted()
      : delivery.reauthentication_timer;

    return {
      name: delivery?.resident_name || "N/A",
      wing: delivery?.wing_name || "—",
      flat: delivery?.flat_no || "—",
      parcel: delivery?.number_of_parcel || 1,
      reauthentication_timer: adjustedTimer,
      authentication_count: delivery?.authentication_count ?? 0,
      circular_loader: delivery?.circular_loader || "stop",
      authentication: delivery?.is_authenticated || "pending",
      resident_token: delivery?.resident_token,
      resident_phone_number: delivery?.resident_phone_number || "N/A",
      resident_approval_link: delivery?.resident_approval_link || "N/A",
      company_nm: session?.company_nm || "Delivery Company",
    };
  });

  const [loadingRows, setLoadingRows] = useState(members.map(() => true));

  useEffect(() => {
    console.log("🚚 Session Data", session.deliveries);
    console.log("length of deliveries", session?.deliveries?.length);
    console.log("📦 Total deliveries:", session?.total_no_of_delivery);
    console.log("📍 Pin code:", session?.pin_code);
  }, [session]);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft =
        scrollContainerRef.current.scrollWidth;
    }
  }, []);

  const handleSubmit = async (stepNumber) => {
    if (stepNumber === 2) {
      setStep?.(2); // Use setStep only for Add Member
      return;
    }

    try {
      setIsSubmitting(true); // ✅ START LOADING SPINNER

      console.log("Proceeding to next step:", stepNumber);
      if (session?.deliveries) {
        const deliveryCount = Object.keys(session.deliveries).length;
        console.log("📦 Delivery count:", deliveryCount);

        const updatedSession = {
          ...session,
          total_no_of_delivery: deliveryCount, // ✅ just replace, no addition
          web_status: "completed",
        };

        setSession(updatedSession);
        localStorage.setItem("deliverySession", JSON.stringify(updatedSession));

        console.log(
          "✅ Updated session with total deliveries:",
          updatedSession.total_no_of_delivery
        );

        console.log("session data complete", updatedSession);
        // Update state + localStorage
        // setSession(updatedSession);
        // localStorage.setItem("deliverySession", JSON.stringify(updatedSession));

        // Send to backend API
        if (session?.status === "inactive") {
          console.log("📤 Sending session because status is INACTIVE");

          const sendResult = await sendDeliverySessionAPI(updatedSession);

          if (sendResult.success) {
            setStep?.(stepNumber);
          }

          console.log("✅ Session sent to API:", sendResult);

        } else {
          console.log("🚫 Skipping API call because status is ACTIVE");

          // still allow navigation if needed
          setStep?.(stepNumber);
        }

        resetSessionForNextUse();
        console.log("Debugging Cleared Session", updatedSession);
        // const clearedSession = {
        //   ...updatedSession,
        //   deliveries: {},
        //   web_status: "active",
        //   total_no_of_delivery: 0,
        //   delivery_qr_code_shortlink: "",
        //   dp_web_session_otp: "",
        // };

        // setSession(clearedSession);
        // localStorage.removeItem("returnToStep");
        // localStorage.setItem("deliverySession", JSON.stringify(clearedSession));

        console.log("🧹 Cleared session and going to Home Page...");
      }
    } catch (err) {
      console.error("❌ Submit failed:", err);
    } finally {
      setIsSubmitting(false); // ✅ STOP LOADING SPINNER
    }
  };

  const formatName = (fullName) => {
    const parts = fullName.trim().split(" ");
    const firstName = parts[0];
    const fName10letters =
      firstName.length <= 10 ? firstName : firstName.slice(0, 10) + "..";
    if (parts.length === 1) return fName10letters;
    return `${fName10letters} ${parts[1][0].toUpperCase()}.`;
  };

  // const [loadingRows, setLoadingRows] = useState(
  //   mockMembers.map((member) => member.authentication === "pending1")
  // );

  // calling parcel approval status form s3 every 10 secondss
  useEffect(() => {
    if (
      !session?.deliveries?.length ||
      !session.deliveries[0].session_file_name ||
      !session.deliveries[0].complex_location ||
      !session.deliveries[0].complex_name
    )
      return;

    const payload = {
      session_file_name: session.deliveries[0].session_file_name,
      complex_location: session.deliveries[0].complex_location,
      complex_name: session.deliveries[0].complex_name,
    };

    const pollSessionData = async () => {
      try {
        const response = await monitorResidentAuth(payload);
        const newDeliveries = response?.data?.session_data?.deliveries || [];
        const currentDeliveries = session?.deliveries || [];

        // Store the full response if session status is not "inactive"
        const newSessionData = response?.data?.session_data;

        if (newSessionData && newSessionData.status !== "inactive") {
          console.log(" Updating session because status is ACTIVE");

          setSession(newSessionData);
          localStorage.setItem(
            "deliverySession",
            JSON.stringify(newSessionData)
          );
        }

        if (!newDeliveries.length || !currentDeliveries.length) return;

        const updatedDeliveries = currentDeliveries.map((oldDelivery) => {
          const match = newDeliveries.find(
            (newDelivery) =>
              newDelivery.resident_token === oldDelivery.resident_token
          );

          if (
            match &&
            match.is_authenticated !== oldDelivery.is_authenticated
          ) {
            return {
              ...oldDelivery,
              is_authenticated: match.is_authenticated,
            };
          }

          return oldDelivery;
        });

        const hasChanges = updatedDeliveries.some(
          (d, i) => d.is_authenticated !== currentDeliveries[i].is_authenticated
        );

        if (hasChanges) {
          setSession((prev) => ({
            ...prev,
            deliveries: updatedDeliveries,
          }));
          console.log("✅ Authentication status updated in session.");
        } else {
          console.log("ℹ️ No changes in authentication status.");
        }
      } catch (err) {
        console.error("❌ Failed to poll session:", err);
      }
    };

    pollSessionData(); // Initial call

    const interval = setInterval(pollSessionData, 10000); // every 10s

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b px-1 py-6 sm:px-8">
      {isSubmitting && (
        <LoadingSpinner message={t("submittingDeliverySession")} />
      )}

      <CommonTitle
        title={t("deliverySummary")}
        showTitle={true}
        showBack={false}
        rightAction={
          <div className="flex items-center gap-8 lg:pr-[10px] xl:pr-[210px] 2xl:pr-[260px]">
            {/* REFRESH */}
            <button
              onClick={handleRefresh}
              disabled={isRefreshing}
              className={`flex flex-col items-center justify-center w-[40px] h-[50px] gap-[5px] 
                ${isRefreshing ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              <img
                src={refreshIcon}
                alt="Refresh"
                className={`w-[30px] h-[30px] ${
                  isRefreshing ? "animate-spin" : ""
                }`}
              />
              <span className="text-[#2699FF] text-xs font-medium mt-1">
                {t("refresh")}
              </span>
            </button>

            {/* location */}
            <button
              onClick={() => {
                const lat = 19.2517246;
                const lng = 72.8659305;

                const url = `https://www.google.com/maps?q=${lat},${lng}&z=18`;
                window.open(url, "_blank");
              }}
              className="flex flex-col items-center justify-center w-[50px] h-[50px] gap-[5px]"
            >
              <img
                src={locationIcon}
                alt="Location"
                className="w-[35px] h-[32px]"
              />
              <span className="text-[#ED4242] text-xs font-medium mt-1">
                {t("location")}
              </span>
            </button>

            {/* ADD MEMBER */}
            <button
              className="flex flex-col items-center justify-center w-[50px] h-[50px] gap-[5px]"
              onClick={() => {
                localStorage.setItem("returnToStep", "5");

                if (session?.status !== "inactive") {
                  setPopupData({
                    title: t("sessionInactiveTitle"),
                    message: t("sessionInactiveMessage", { status: session?.status }),
                    singleButton: true,
                    singleButtonLabel: t("okay"),
                  });
                  setShowPopup(true);
                  return;
                }

                if (
                  session?.deliveries?.length < session?.total_no_of_delivery
                ) {
                  handleSubmit(2);
                } else {
                  setPendingStep(2);  
                  setShowPendingPopup(true);
                }
              }}
            >
              <img
                src={addMemberIcon}
                alt="Add Member"
                className="w-[35px] h-[32px]"
              />
              <span className="flex flex-col items-center justify-center w-[70px] h-[50px] gap-[5px] text-[#14AE5C] text-xs font-medium mt-1">
                <span className="whitespace-nowrap leading-none">
                  {t("addMember")}
                </span>
              </span>
            </button>
          </div>
        }
      />

      <div
        ref={scrollContainerRef}
        className="overflow-x-auto max-w-4xl mx-auto bg-white rounded-t-xl shadow-md mt-[20px]"
      >
        <table className="min-w-max w-full text-center border-collapse">
          <thead className="bg-[#063367] text-white text-sm sm:text-base">
            <tr>
              <th className="sticky left-0 bg-[#063367] z-10 px-4"></th>
              <th className="sticky left-[40px] bg-[#063367] z-10 py-3 pl-6 text-left">
                {t("name")}
              </th>
              <th>{t("wing")}</th>
              <th>{t("flatNo")}</th>
              <th>{t("parcel")}</th>
              <th>{t("authentication")}</th>
              <th> </th>
            </tr>
          </thead>
          <tbody className="text-sm sm:text-base">
            {members.map((member, index) => (
              <tr
                key={index}
                className={
                  editingToken === member.resident_token ? "bg-[#E3E3E3]":
                  index % 2 === 0 ? "bg-blue-50" : "bg-white"
                }
              >
                <td className="sticky left-0 bg-inherit z-10 px-4">
                  {index + 1}
                </td>
                <td className="sticky left-[40px] bg-inherit z-10 py-3 pl-6 font-medium text-left">
                  {formatName(member.name)}
                </td>
                <td>{member.wing}</td>
                <td>{member.flat}</td>
                {editingToken === member.resident_token ? (
                  <td>
                    <div className="flex justify-center">
                      <div className="flex items-center bg-white rounded-full px-2 py-1 shadow border gap-4">

                        {/* MINUS */}
                        <button
                          className="w-7 h-7 flex items-center justify-center rounded-full bg-red-200 text-red-600 text-xl font-bold"
                          onClick={() =>
                            setEditingParcelValue((prev) => Math.max(1, prev - 1))
                          }
                        >
                          −
                        </button>

                        {/* COUNT */}
                        <span className="font-semibold text-lg w-6 text-center">
                          {editingParcelValue}
                        </span>

                        {/* PLUS */}
                        <button
                          className="w-7 h-7 flex items-center justify-center rounded-full bg-[#2E5AAC] text-white text-xl font-bold"
                          onClick={() =>
                            setEditingParcelValue((prev) => Math.min(10, Number(prev) + 1))
                          }
                        >
                          +
                        </button>

                      </div>
                    </div>
                  </td>
                ) : (
                  <td>{member.parcel}</td>
                )}


                <td className="py-2">
                  {editingToken === member.resident_token ? (
                    <div className="flex justify-center gap-3">

                      {/* SAVE (only if changed) */}
                      {Number(editingParcelValue) !== Number(originalParcelValue) && (
                        <button
                          className="bg-[#FFED25] text-black font-semibold text-sm px-4 py-1 rounded-2xl"
                          onClick={() => {
                            // 1️⃣ Update session parcel count
                            setSession((prev) => ({
                              ...prev,
                              deliveries: prev.deliveries.map((d) =>
                                d.resident_token === member.resident_token
                                  ? { ...d, number_of_parcel: Number(editingParcelValue) }
                                  : d
                              ),
                            }));

                            // 2️⃣ Update Dashboard props safely
                            setResidentDetails({
                              resident_id: member.resident_token
                            });

                            setParcelCount(Number(editingParcelValue));

                            // 3️⃣ Exit UI edit mode
                            setEditingToken(null);
                            setEditingParcelValue(null);
                            setOriginalParcelValue(null);

                            // 4️⃣ Jump to Step-4
                            setStep(4);
                          }}
                        >
                          {t("capture")}
                        </button>
                      )}

                      {/* CANCEL */}
                      <button
                        className="bg-black text-white text-sm px-4 py-1 rounded-2xl"
                        onClick={() => {
                          setEditingToken(null);
                          setEditingParcelValue(null);
                          setOriginalParcelValue(null);
                        }}
                      >
                        {t("cancel")}
                      </button>

                    </div>
                  ) : (
                    /* 🔁 EXISTING AUTH LOGIC (UNCHANGED) */
                    <>
                      {member.authentication_count >= 3 &&
                  member.authentication === "pending" ? (
                    <img
                      src={getComeLaterImage()}
                      alt="Come Later"
                      className="w-15 h-8 mx-auto"
                    />
                  ) : member.authentication_count < 3 &&
                    member.authentication_count >= 1 &&
                    member.circular_loader === "stop" &&
                    member.authentication === "pending" ? (
                    <button
                      className="bg-[#34A853] hover:bg-[#34A853] text-white text-sm px-3 py-1 rounded mx-[4px]"
                      onClick={() => {
                        const now = new Date();
                        const pad = (n) => n.toString().padStart(2, "0");
                        const formattedTime = `${pad(now.getHours())}:${pad(
                          now.getMinutes()
                        )}:${pad(now.getSeconds())}`;
                        console.log(
                          "🔁 Re-authenticate button pressed at:",
                          formattedTime
                        );

                        // ✅ Update the delivery session for the matching resident
                        setSession((prevSession) => {
                          if (!prevSession?.deliveries) return prevSession;

                          const updatedDeliveries = prevSession.deliveries.map(
                            (delivery) => {
                              if (
                                delivery.resident_token ===
                                member.resident_token
                              ) {
                                return {
                                  ...delivery,
                                  reauthentication_timer: formattedTime,
                                  circular_loader: "start",
                                };
                              }
                              return delivery;
                            }
                          );

                          return {
                            ...prevSession,
                            deliveries: updatedDeliveries,
                          };
                        });

                        // ✅ Call message API function
                        sendAuthenticationMessage(member);
                      }}
                    >
                      {t("reAuthenticate")}
                    </button>
                  ) : member.authentication === "pending" ? (
                    isWithin30Seconds(member.reauthentication_timer) ? (
                      <div className="flex justify-center items-center h-11">
                        <CircularTimerLoader
                          startTime={member.reauthentication_timer}
                          resident_token={member.resident_token}
                          setSession={setSession}
                        />
                      </div>
                    ) : (
                      <button
                        className="bg-[#34A853] hover:bg-[#34A853] text-white text-sm px-3 py-1 rounded mx-[4px]"
                        onClick={() => {
                          const now = new Date();
                          const pad = (n) => n.toString().padStart(2, "0");
                          const formattedTime = `${pad(now.getHours())}:${pad(
                            now.getMinutes()
                          )}:${pad(now.getSeconds())}`;
                          console.log(
                            "🔁 Re-authenticate button pressed at:",
                            formattedTime
                          );

                          setSession((prevSession) => {
                            if (!prevSession?.deliveries) return prevSession;

                            const updatedDeliveries =
                              prevSession.deliveries.map((delivery) => {
                                if (
                                  delivery.resident_token ===
                                  member.resident_token
                                ) {
                                  return {
                                    ...delivery,
                                    reauthentication_timer: formattedTime,
                                    circular_loader: "start",
                                  };
                                }
                                return delivery;
                              });

                            return {
                              ...prevSession,
                              deliveries: updatedDeliveries,
                            };
                          });
                        }}
                      >
                        {t("reAuthenticate")}
                      </button>
                    )
                  ) : member.authentication === "True" ? (
                    <img
                      src={tickIcon}
                      alt="Authenticated"
                      className="w-5 h-5 mx-auto"
                    />
                  ) : member.authentication === "False" ? (
                    <img
                      src={crossIcon}
                      alt="Not Authenticated"
                      className="w-5 h-5 mx-auto"
                    />
                  ) : null}
                    </>
                  )}
                </td>
                
                <td className="px-2">
                  {editingToken === member.resident_token ? null : (
                    <button
                      onClick={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        setActiveMenuToken(member.resident_token); // track row
                        setMenuPosition({
                          top: rect.bottom + window.scrollY + 4,
                          left: rect.left + window.scrollX - 120,
                        });
                      }}
                    >
                      <img src={three_dots} className="w-1 h-5 " />
                    </button>
                  )}
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-center mt-10">
        <button
          onClick={() => {
            setPendingStep(0);
            setShowPendingPopup(true);
          }}
          className="flex flex-col items-center bg-white/10 backdrop-blur-md shadow-md rounded-lg p-4 border border-gray-200 hover:shadow-lg"
        >
          {/* Image with green tick overlay */}
          <div className="relative">
            <img
              src={boxIcon}
              alt="box"
              className="w-20 h-20 sm:w-16 sm:h-16 object-contain"
            />
          </div>

          {/* White box below image */}
          <div className="mt-2 px-4 py-3 bg-white rounded-md border-[#A5B6C8] border">
            <span className="text-[#063367] font-semibold text-base sm:text-lg text-center">
              {t("submitAndGoHome")}
            </span>
          </div>
        </button>
      </div>

      {/* single optionn */}
      <CommonPopup
        isOpen={showPopup}
        title={popupData.title}
        message={popupData.message}
        singleButton={popupData.singleButton}
        singleButtonText={popupData.singleButtonLabel}
        onPrimary={() => setShowPopup(false)}
        onClose={() => setShowPopup(false)}
      />

      <CommonPopup
        isOpen={showPendingPopup}
        title={
          pendingStep === 2
            ? t("addResidentTitle")
            : session.total_no_of_delivery > session.deliveries.length
            ? t("pendingDeliveriesTitle", {
                count: session.total_no_of_delivery - session.deliveries.length,
              })
            : t("allDeliveriesAddedSuccessfully")
        }
        message={
          pendingStep === 2
            ? t("addedAllDeliveriesWantMore", {
                count: session.deliveries.length,
              })
            : t("areYouSureYouWantToGoForDelivery")
        }
        primaryText={pendingStep === 2 ? t("addResidentButton") : t("continueButton")}
        secondaryText={t("cancel")}
        onPrimary={() => {
          setShowPendingPopup(false);
          handleSubmit(pendingStep);
        }}
        onSecondary={() => {
          setShowPendingPopup(false);
        }}
        imageType={
          pendingStep === 2
            ? "add"
            : session.total_no_of_delivery > session.deliveries.length
            ? "pending"
            : "success"
        }
      />



      {menuPosition && (
        <>
          {/* DULL BACKGROUND */}
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-40"
            onClick={() => 
              {
                // setEditingToken(member.resident_token);
                setMenuPosition(null);
                setActiveMenuToken(null);
              }}
          />

          {/* CONTEXT MENU */}
          <div
            className="absolute bg-white rounded-xl shadow-lg z-50 px-10 py-3 -translate-y-12 -translate-x-20 sm:-translate-x-20"
            style={{
              top: menuPosition.top,
              left: menuPosition.left,
              minWidth: "180px"
            }}
          >
            <button
              className="w-full text-center font-medium text-[#2E2E5D] whitespace-nowrap text-sm md:text-base"
              onClick={() => {
                const delivery = session.deliveries.find(
                  (d) => d.resident_token === activeMenuToken
                );

                const currentCount = Number(delivery?.number_of_parcel ?? 1);

                setEditingToken(activeMenuToken);
                setEditingParcelValue(currentCount);
                setOriginalParcelValue(currentCount);

                setMenuPosition(null);
                setActiveMenuToken(null);
              }}
            >
              {t("editParcelCount")}
            </button>
          </div>
        </>
      )}

    </div>
  );
};

export default DeliverySummaryScreen;
